<template>
    <div>
    <v-container fluid class="mt-9 mt-lg-11 mx-0">
        <v-app-bar app class="primary">
            <v-col cols="4" class="ma-0 pa-0">
                <v-img max-height="60px" :max-width="isMobile ? '90px' : '125px'" contain position="left center" src="../assets/whitetransparent.png" style="cursor: pointer" @click.stop="toggleHome"></v-img>
            </v-col>
            <v-spacer/>
            <v-col cols="8" align="end" class="ma-0 pa-0">
                <v-btn color="white" outlined class="mr-2 font-weight-normal" @click.stop="loginUser">Login</v-btn>
                <!-- <v-btn color="white" outlined class="mr-2 font-weight-normal" :to="{name: 'login'}">Login</v-btn> -->
                <!-- <v-btn color="white" outlined class="font-weight-normal" :to="{name: 'signup'}">Sign Up</v-btn> -->
                <v-btn color="white" outlined class="font-weight-normal" @click.stop="signupUser">Sign Up</v-btn>
            </v-col>
            <!-- HELP BUTTON -->
            <transition name="fade">
                <div v-if="showIsGroupPostIndicator" class="d-flex flex-column"  style="position: absolute; bottom: -60px; right: 0px;">
                    <v-icon class="align-self-center">mdi-arrow-up-bold</v-icon>
                    <p class="rounded-xl white--text accent py-1 px-3">Are you part of this group? Click here to Login.</p>
                </div>
            </transition>
            <!-- END -- HELP BUTTON -->
        </v-app-bar>
        <v-row justify="center" no-gutters class="px-lg-15 mt-5 mx-0 py-0">
            <v-col cols="12" xl="7" lg="8" md="12" sm="12" xs="12" class="pr-lg-5">
                <v-row v-if="viewLoading" justify="center" no-gutters>
                    <v-col cols="12">
                        <v-skeleton-loader height="600" type="image" class="hidden-md-and-down"></v-skeleton-loader>
                        <!-- <v-skeleton-loader height="600" type="image" class="hidden-xl-only hidden-md-and-down"></v-skeleton-loader> -->
                        <v-skeleton-loader height="450" type="image" class="hidden-lg-and-up hidden-xs-only"></v-skeleton-loader>
                        <v-skeleton-loader height="200" type="image" class="hidden-sm-and-up"></v-skeleton-loader>
                    </v-col>
                </v-row>

                <v-row v-else>
                    <v-col cols="12">
                        <VideoPlayer
                            v-if="postData.videoUrl && postData.videoType"
                            ref="vidPlayer"
                            :options="vidOptions"
                            :isCreating="false"
                            :videoLoading="videoLoading"
                            :anonymousMode="postData.anonymousMode || false"
                            :showCaptions="showCaptions"
                            :advancedControlsTooltip="signedInUserId ? 'Advanced Controls are available in the full viewer' : 'Log in to access Advanced Controls'"
                            :autoplayOnControlsEnabled="false"
                            :playbackStyle="playbackStyle"
                            @advancedControlsClicked="advancedControlsUnavailable"
                            @seeked="videoPlayerSeeked"
                            @hasBegunPlaying="audioElementHasBegunPlaying = true"
                            @playAudioPlayer="playAudioPlayer"
                            @pauseAudioPlayer="pauseAudioPlayer"
                            @controlsEnabled="(($refs.vidPlayer.getMarkers().length <= 0) && $refs.vidPlayer.placeMarkers(currentAudioElement.audioData.audio, currentAudioElement.audioData.subtitles, currentAudioElement.audioData.username))"
                            @playerReady="getAudioData"
                            @timeUpdate="timeUpdate"
                            @markerClicked="markerClicked"
                        />
                    </v-col>
                </v-row>

                <!-- Settings status bar — public route. Read-only: appears only when a &share=1
                     link overrides playback, or an educational hint applies. It never exposes
                     controls (those are authenticated-only) — the only actions are a free revert
                     to standard playback and a sign-in nudge. On a plain public post nothing here
                     is true, so the bar stays hidden. -->
                <v-row v-if="showSettingsStatusBar" justify="center" no-gutters class="mt-1 mb-0">
                    <v-col cols="12">
                        <v-alert
                            type="info"
                            dense
                            class="mb-0 text-body-2"
                            dismissible
                            @input="dismissStatusBar"
                        >
                            <div v-if="senderSettingsActive">
                                Viewing with the sender's settings · 
                                <a href="#" class="font-weight-medium white--text" @click.prevent="useStandardSettings">Use standard settings</a>
                                <span class="mx-1">·</span>
                                <a href="#" class="font-weight-medium white--text" @click.prevent="goToSignIn">Sign in</a> to save your own
                            </div>
                            <!-- Overlap hint: continuous mode with both tracks audible -->
                            <div v-if="showOverlapHint" :class="{ 'mt-1': senderSettingsActive }">
                                🎙 Caption audio is playing — lower video volume to hear it clearly · 
                                <a href="#" class="font-weight-medium white--text" @click.prevent="muteVideo">Mute video</a>
                            </div>
                            <!-- Dead-air hint: pauseplay + muted caption audio -> silent pauses -->
                            <div v-if="showDeadAirHint" :class="{ 'mt-1': senderSettingsActive || showOverlapHint }">
                                🔇 Caption audio is muted — playback will pause in silence · 
                                <a href="#" class="font-weight-medium white--text" @click.prevent="unmuteCaptionAudio">Unmute</a>
                            </div>
                        </v-alert>
                    </v-col>
                </v-row>
                

                <div class="full-width" style="position: relative; max-width: 100%;">
                    <v-row justify="space-around" align="center" no-gutters class="mt-5">
                        <v-col cols="10">
                            <span class="text-h5 text-xl-h4 text-lg-h4 font-weight-bold">{{postData.title}}</span>
                        </v-col>

                        <v-col cols="2" align="end">
                            <v-menu v-model="menu" rounded="lg" offset-y bottom origin="center" transition="scale-transition" close-on-content-click>
                                <template v-slot:activator="{ on }">
                                    <v-btn v-on="on" @click.stop="menu = !menu" icon :disabled="showIsGroupPostIndicator || postDoesNotExist">
                                        <v-icon :color="$vuetify.theme.dark ? 'amber' : 'primary'">mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list rounded>
                                    <v-list-item @click.stop="showShareDialog = true, menu = !menu"> 
                                        <v-icon class="pr-2">mdi-share</v-icon>Share<br>
                                    </v-list-item>
                                    <v-list-item @click.stop="reportDialog = true, menu = !menu">
                                        <v-icon class="pr-2">mdi-flag</v-icon>Report
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                            <Report v-if="reportDialog" :dialog="reportDialog" page="viewPost" :post="postData" @close-report="reportDialog = false"/>
                            <ShareDialog
                                v-if="showShareDialog"
                                :dialog="showShareDialog"
                                :postData="postData"
                                :senderSettings="{
                                    ps: playbackStyle,
                                    sc: showCaptions ? '1' : '0',
                                    cv: String(captionVolume),
                                    vv: String(videoVolume)
                                }"
                                @close-dialog="showShareDialog = false"
                            />
                        </v-col>
                    </v-row>

                    <div v-if="viewFullDescription" class="full-width" style="position: relative; max-width: 100%;">
                        <v-row justify="start" align="center" no-gutters class="my-3">
                            <p style="cursor: pointer;" class="subtitle-2 font-weight-light font-italic mb-0 py-0 accent--text" @click.stop="consoleLogToUser('name')"> @{{postData.username ? postData.username : 'Unknown' }}</p>
                            <span class="px-2">|</span>
                            <p class="subtitle-2 font-weight-light mb-0 py-0">{{postData.postDate}}</p>
                        </v-row>

                        <!-- We only want the view more/less button to come up on small size viewports and down -->
                        <!-- Therefore we will check for that here. If it is small >= then only show the condensed version and the view more button if the description length is greater than 150  -->
                        <v-row justify="start" align="center" no-gutters>
                            <span style="max-width: 100%; overflow-x: hidden;" class="subtitle-1 text--secondary font-weight-light">{{postData.description}}</span>
                        </v-row>


                        <v-row justify="space-between" no-gutters class="my-2">
                            <v-col cols="12" xl="4" lg="5" md="5" sm="5" class="my-md-0 my-1">
                                <v-row justify="start" align="center" no-gutters>
                                    <span class="text-subtitle-2 font-weight-light mr-2">Playback:</span>
                                    <v-btn text :ripple="false" class="px-2" :disabled="showIsGroupPostIndicator || postDoesNotExist" :style="{ opacity: playbackStyle === 'continuous' ? 1 : 0.55, textTransform: 'none' }" title="Play the captions and audio without the video pausing" @click.stop="playbackStyle = 'continuous'">
                                        <v-icon :color="playbackStyle === 'continuous' ? 'primary' : 'grey'">mdi-autorenew</v-icon>
                                        <span class="ml-1 text-caption" :class="playbackStyle === 'continuous' ? 'white--text' : 'grey--text'">Continuous</span>
                                    </v-btn>
                                    <v-btn text :ripple="false" class="px-2" :disabled="showIsGroupPostIndicator || postDoesNotExist" :style="{ opacity: playbackStyle === 'pauseplay' ? 1 : 0.55, textTransform: 'none' }" title="The video will pause while the captions and audio play" @click.stop="playbackStyle = 'pauseplay'">
                                        <v-icon :color="playbackStyle === 'pauseplay' ? 'primary' : 'grey'">mdi-play-pause</v-icon>
                                        <span class="ml-1 text-caption" :class="playbackStyle === 'pauseplay' ? 'white--text' : 'grey--text'">Pause/Play</span>
                                    </v-btn>
                                </v-row>
                            </v-col>

                            <v-col cols="12" xl="3" lg="3" md="2" sm="2" class="my-md-0 my-1">
                                <v-row :justify="isMobile ? 'start' : 'center'" align="center" class="ma-0 pa-0">
                                    <span class="mr-2 text-subtitle-2 font-weight-light">Captions:</span>
                                    <v-switch v-model="showCaptions" color="primary" :label="showCaptions ? 'ON' : 'OFF'"></v-switch>
                                </v-row>
                            </v-col>

                            <v-col cols="12" xl="5" lg="4" md="5" sm="5" class="my-md-0 my-1">
                                <v-slider
                                    v-model="captionVolume"
                                    label="Caption Audio"
                                    inverse-label
                                    :prepend-icon="captionVolume > 0 ? 'mdi-volume-medium' : 'mdi-volume-variant-off'"
                                    @click:prepend="adjustSegmentVolume('mute')"
                                    @click:append="adjustSegmentVolume(1.0)"
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    v-on:end="adjustSegmentVolume"
                                    v-on:click="adjustSegmentVolume(captionVolume)"
                                    dense
                                    hide-details
                                    :disabled="showIsGroupPostIndicator || postDoesNotExist"
                                ></v-slider>
                            </v-col>

                            <v-col cols="12" xl="5" lg="4" md="5" sm="5" class="my-md-0 my-1">
                                <v-slider
                                    v-model="videoVolume"
                                    label="Video Audio"
                                    inverse-label
                                    :prepend-icon="videoVolume > 0 ? 'mdi-volume-high' : 'mdi-volume-off'"
                                    @click:prepend="adjustVideoVolume(videoVolume > 0 ? 0 : 1.0)"
                                    @click:append="adjustVideoVolume(1.0)"
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    v-on:end="adjustVideoVolume"
                                    v-on:click="adjustVideoVolume(videoVolume)"
                                    dense
                                    hide-details
                                    :disabled="showIsGroupPostIndicator || postDoesNotExist"
                                ></v-slider>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="!viewFullDescription" v-bind:class="[$vuetify.theme.dark ? 'faded-dark' : 'faded']"></div>
                    <div style="width: 100%;" class="d-flex justify-space-around align-center">
                        <v-divider/>
                        <!-- <p class="text-caption primary--text mb-0 px-2" @click="viewFullDescription = !viewFullDescription">{{ viewFullDescription ? 'View Less' : 'View More'}}</p> -->
                        <v-btn text x-small :ripple="false" color="primary" @click="viewFullDescription = !viewFullDescription">
                            <!-- <v-icon color="primary">{{ viewFullDescription ? 'mdi-triangle-small-up' : 'mdi-triangle-small-down'}}</v-icon> -->
                            <v-icon color="primary">{{ viewFullDescription ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                            {{ viewFullDescription ? 'View Less' : 'View More'}}
                            <!-- <v-icon color="primary">{{ viewFullDescription ? 'mdi-triangle-small-up' : 'mdi-triangle-small-down'}}</v-icon> -->
                            <v-icon color="primary">{{ viewFullDescription ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                        </v-btn>
                        <v-divider/>
                    </div>
                </div>
            </v-col>

            <v-col cols="12" xl="3" lg="4" md="12" sm="12" xs="12" style="max-height: 60vh; overflow-y: hidden; overflow-x: hidden;" class="bordered mt-5 mt-xl-0 mt-lg-0">
                <!-- style="max-height: 80vh; overflow-y: scroll; overflow-x: hidden;" -->
                <!-- we want to see if there are more than 2 in the array because we start with one ('all'), and only want to filter if there are more than 1 language in the audiodata. -->
                <v-row justify="end" align="center" no-gutters class="mx-0 mt-2 px-5">
                    <v-col v-if="!isMobile" cols="12" xl="7" lg="11" md="3" sm="4" xs="12" align="center">
                        <v-autocomplete v-if="filter.languageCodes.length > 1 || !audioLoading" v-model="filter.languageSelected" :items="filter.languageCodes" label="Filter by language" append-icon="mdi-filter-menu" hide-details :disabled="showIsGroupPostIndicator" class="children-cursor--pointer"/>
                        <v-skeleton-loader v-else type="text@2" class="pa-2"></v-skeleton-loader>
                    </v-col>
                </v-row>
                <!-- CAPTION SEARCH (ported from ViewPost.vue) — searches all subtitles across every
                     contribution and drops colored markers on the video timeline at each match -->
                <v-row justify="center" align="center" no-gutters class="mx-0 mt-2 px-5">
                    <v-col style="flex: 1 1 0; min-width: 140px;">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">
                                    <v-text-field
                                        v-model="searchQuery"
                                        :label="isMobile ? null : 'Search captions'"
                                        :placeholder="isMobile ? 'Search captions' : null"
                                        prepend-inner-icon="mdi-magnify"
                                        clearable
                                        hide-details
                                        dense
                                        single-line
                                    ></v-text-field>
                                </div>
                            </template>
                            <span>Search all subtitles on this video</span>
                        </v-tooltip>
                    </v-col>
                    <!-- Color picker toggle: small dot showing current color. Tap/click to expand swatches. -->
                    <div v-if="searchQuery" style="flex: 0 0 auto;" class="ml-2">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                    v-bind="attrs"
                                    v-on="on"
                                    @click.stop="showColorPicker = !showColorPicker"
                                    :style="{
                                        backgroundColor: searchHighlightColor,
                                        width: '22px',
                                        height: '22px',
                                        borderRadius: '50%',
                                        cursor: 'pointer',
                                        border: showColorPicker ? '2px solid white' : '2px solid rgba(255,255,255,0.4)',
                                        boxShadow: showColorPicker ? '0 0 0 1px ' + searchHighlightColor : 'none',
                                        transition: 'border 0.15s, box-shadow 0.15s',
                                    }"
                                ></div>
                            </template>
                            <span>{{ showColorPicker ? 'Hide color options' : 'Change search highlight color' }}</span>
                        </v-tooltip>
                    </div>
                </v-row>
                <!-- Search highlight color picker — expands when user taps the color dot -->
                <v-expand-transition>
                    <v-row v-if="searchQuery && showColorPicker" justify="center" align="center" no-gutters class="mx-0 mt-2 px-5">
                        <div class="d-flex align-center justify-start" style="gap: 8px;">
                            <span class="text-caption grey--text">Highlight:</span>
                            <div
                                v-for="color in searchColorOptions"
                                :key="color"
                                @click.stop="setSearchColor(color); showColorPicker = false;"
                                :style="{
                                    backgroundColor: color,
                                    width: '22px',
                                    height: '22px',
                                    borderRadius: '50%',
                                    cursor: 'pointer',
                                    border: searchHighlightColor === color ? '2px solid white' : '2px solid transparent',
                                    boxShadow: searchHighlightColor === color ? '0 0 0 1px ' + color : 'none',
                                }"
                            ></div>
                        </div>
                    </v-row>
                </v-expand-transition>
                <!-- DISMISSIBLE HINT FOR UNAUTHENTICATED USERS -->
                <v-row v-if="!signedInUserId && !dismissContributeHint" justify="center" align="center" class="mx-0 mt-2 px-5">
                    <v-icon small color="primary" class="mr-1">mdi-microphone-plus</v-icon>
                    <span class="text-caption primary--text" style="cursor:pointer;"
                        @click.stop="contributeDialog = true">
                        Sign in to contribute your language
                    </span>
                    <v-icon x-small class="ml-2" style="cursor:pointer;"
                            @click.stop="dismissContributeHint = true">
                        mdi-close
                    </v-icon>
                </v-row>
                <!-- CONTRIBUTE BUTTON -->
                <v-row justify="center" align="center" class="mx-0 mb-2 px-5">
                    <v-divider/>
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" @click.stop="consoleLogToUser('contribute')" depressed :disabled="showIsGroupPostIndicator || postDoesNotExist" color="primary">Contribute
                                <v-icon right>mdi-plus</v-icon>
                            </v-btn>
                        </template>
                        <span>Add your own audio and subtitles</span>
                    </v-tooltip>
                    <v-divider/>
                </v-row>

                <v-row style="max-height: 50vh; overflow-y: scroll;" class="bordered mx-0 px-5">
                    <!-- style="max-height: 100vh; overflow-y: scroll;" -->
                    <v-row v-if="audioLoading" class="my-0 py-0">
                        <v-col v-for="i in 3" :key="i" cols="6" class="my-0 pt-0 px-2 pb-5 hidden-lg-and-up hidden-xs-only">
                            <v-skeleton-loader height="100" type="image" class="rounded-lg"></v-skeleton-loader>
                        </v-col>
                        <v-col v-for="i in 3" :key="i+3" cols="6" class="my-0 pt-0 px-2 pb-5 hidden-lg-and-up hidden-xs-only">
                            <v-skeleton-loader height="100" type="image" class="rounded-lg"></v-skeleton-loader>
                        </v-col>
                    </v-row>

                    <v-col v-if="leftAudioData.length > 0" cols="12" xs="12" md="6" lg="12" xl="12" class="hidden-xs-only hidden-lg-and-up ma-0 pl-0 py-0 justify-end">
                        <v-container fluid v-for="audio in leftAudioData" :key="audio.audioDataId" class="pt-0 px-0 pb-5">
                            <ElementAudio
                                v-if="audio.audioData.audio.length > 0"
                                :audioObject="audio"
                                :postAudioDataId="postData.postAudioDataId"
                                :selectedAudioId="selectedAudioId"
                                :currentSegmentIndex="currentSegmentIndexForElement(audio.audioDataId)"
                                :postType="postType"
                                :postData="postData"
                                :videoLoading="videoLoading"
                                :audioElementHasBegunPlaying="audioElementHasBegunPlaying"
                                :searchQuery="searchQuery"
                                :searchHighlightColor="searchHighlightColor"
                                :anonymousMode="postData.anonymousMode || false"
                                @audioChanged="changeElementAudio"
                                @changeElementAudio="changeSegmentAudio"
                                @usernameClicked="consoleLogToUser"
                            />
                        </v-container>
                    </v-col>

                    <v-col v-if="rightAudioData.length > 0" cols="12" xs="12" md="6" lg="12" xl="12" class="hidden-xs-only hidden-lg-and-up ma-0 pr-0 py-0 justify-end">
                        <v-container fluid v-for="audio in rightAudioData" :key="audio.audioDataId" class="pt-0 px-0 pb-5">
                            <ElementAudio
                                v-if="audio.audioData.audio.length > 0"
                                :audioObject="audio"
                                :postAudioDataId="postData.postAudioDataId"
                                :selectedAudioId="selectedAudioId"
                                :currentSegmentIndex="currentSegmentIndexForElement(audio.audioDataId)"
                                :postType="postType"
                                :postData="postData"
                                :videoLoading="videoLoading"
                                :audioElementHasBegunPlaying="audioElementHasBegunPlaying"
                                :searchQuery="searchQuery"
                                :searchHighlightColor="searchHighlightColor"
                                :anonymousMode="postData.anonymousMode || false"
                                @audioChanged="changeElementAudio"
                                @changeElementAudio="changeSegmentAudio"
                                @usernameClicked="consoleLogToUser"
                            />
                        </v-container>
                    </v-col>

                    <v-col v-if="audioLoading" cols="12" class="hidden-md-only hidden-sm-only">
                        <div v-for="i in 5" :key="i" class="my-0 pt-0 px-0 pb-5">
                            <v-skeleton-loader height="100" type="image" class="rounded-lg"></v-skeleton-loader>
                        </div>
                    </v-col>

                    <v-col v-for="audio in languageFilteredAudio" :key="audio.audioDataId" cols="12" class="hidden-md-only hidden-sm-only my-0 pt-0 px-0 pb-5">
                        <ElementAudio
                            v-if="audio.audioData.audio.length > 0"
                            :audioObject="audio"
                            :postAudioDataId="postData.postAudioDataId"
                            :selectedAudioId="selectedAudioId"
                            :currentSegmentIndex="currentSegmentIndexForElement(audio.audioDataId)"
                            :postType="postType"
                            :postData="postData"
                            :videoLoading="videoLoading"
                            :audioElementHasBegunPlaying="audioElementHasBegunPlaying"
                            :searchQuery="searchQuery"
                            :searchHighlightColor="searchHighlightColor"
                            :anonymousMode="postData.anonymousMode || false"
                            @audioChanged="changeElementAudio"
                            @changeElementAudio="changeSegmentAudio"
                            @usernameClicked="consoleLogToUser"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <!-- CONTRIBUTE DIALOG FOR UNAUTHENTICATED USERS -->
    <v-dialog v-model="contributeDialog" max-width="400">
        <v-card class="pa-4 text-center">
            <v-icon size="48" color="primary" class="mb-3">mdi-microphone-plus</v-icon>
            <v-card-title class="justify-center text-h6 font-weight-bold">
                Contribute Your Language
            </v-card-title>
            <v-card-text class="text-body-1">
                Create an account to add your own audio to this post in any language.
            </v-card-text>
            <v-card-actions class="justify-center flex-column">
                <v-btn color="primary" depressed large block class="mb-2" @click.stop="signupUser">
                    Sign Up Free
                </v-btn>
                <v-btn color="primary" outlined large block class="mb-2" @click.stop="loginUser">
                    Login
                </v-btn>
                <v-btn text small @click.stop="contributeDialog = false">
                    Continue Browsing
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </div>
</template>

<script>
import fb from "firebase/compat/app";
import firebase from "../../firebaseConfig.js";
import VideoPlayer from "./VideoPlayer";
import ElementAudio from "./ElementAudio";
import ShareDialog from "./ShareDialog.vue";
import Report from "./Report.vue";
import { CANONICAL_DEFAULTS } from "../../settingsDefaults.js";

// The public route's out-of-box playback = canon (imported), plus videoVolume — a public-
// route-only value used for share-URL tracking, not part of canon. data() and "Use standard
// settings" read from this, so the anonymous default is 'continuous', matching the
// authenticated route.
const STANDARD_SETTINGS = { ...CANONICAL_DEFAULTS, videoVolume: 1.0 };

export default {
    name: "post-view",
    metaInfo() {
        return {
            title: typeof this.postData.title != 'undefined' ? `${this.postData.title} - tawq.in` : 'Post View - tawq.in',
        }
    },
    props: ["postId", "postType"],
    components: {
        VideoPlayer,
        ElementAudio,
        ShareDialog,
        Report,
    },
    data: function () {
        return {
            menu: false,
            showShareDialog: false,
            showIsGroupPostIndicator: false,
            reportDialog: false,
            viewLoading: true,
            audioLoading: true,
            postData: {}, // computed (currentPost) isn't available yet in data(); populated in fetchPost / created. Matches ViewPost.vue.
            selectedAudioId: null,
            /* ─── Caption search (ported from ViewPost.vue) ─── */
            searchQuery: "",
            searchHighlightColor: localStorage.getItem('tawqSearchColor') || '#FF5722', // shared key with ViewPost so the user's color follows them
            searchColorOptions: ['#FF5722', '#2196F3', '#9C27B0', '#E53935'],
            showColorPicker: false,
            currentAudioElement: null,// this will be the currently selected AudioElement.
            currentAudioSegment: null,// this will be the current segment loaded into the audioPlayer.
            nextAudioSegment: null,// this will be the next audio segment to be loaded into the audioPlayer.
            vidOptions: {
                autoplay: false,
                controls: false,
                responsive: true,
                sources: {},
                techOrder: ["html5", "youtube"],
                textTrackSettings: false,
                html5: {
                nativeTextTracks: false,
                nativeControlsForTouch: false,
                nativeAudioTracks: false,
                },
                youtube: {
                    enablejsapi: 1,
                    fs: 0,
                    playsinline: 1,
                    cc_load_policy: 3,
                    disablekb: 1,
                    ytControls: 0,
                    // origin: "https://tawq.in" || window.location.orgin, // maybe can use this instead of having to comment out below for testing?
                    // origin: "https://tawq.in", // uncomment for deploy to dev/main
                    origin: window.location.origin, // uncomment for testing
                    modestbranding: 1,
                    start: 0,
                    // widget_referrer: "https://tawq.in",
                },
            },
            audioData: [],
            showCaptions: STANDARD_SETTINGS.showCaptions,
            playbackStyle: STANDARD_SETTINGS.playbackStyle,
            audioPlayer: new Audio(),
            preloadAudioPlayer: new Audio(),
            vidPlayerVolume: null,
            captionVolume: STANDARD_SETTINGS.captionVolume,
            viewFullDescription: false,
            descriptionWordCount: 0,
            filter: {
                languageSelected: "All",
                languageCodes: ["All"],
            },
            postViewedCounter: null,
            postDoesNotExist: false,
            videoLoading: true, // Used to put the video player in, or take out of, a loading state. When true the vjs-loading-spinner will show, else it's hidden.
            videoLoadingFallbackTimer: null, // mobile fix: browsers may not fire 'canplaythrough' without a user gesture, which would leave videoLoading true and player controls hidden forever
            audioElementHasBegunPlaying: false,
            audioCanPlay: false, // Used to make sure audio is ready to play when marker is reached.
            // markerHasBeenClicked: false,
            audioElementOrSegmentClicked: false,
            contributeDialog: false,
            dismissContributeHint: false,
            senderSettingsActive: false, // true when opened via share link with &share=1
            dismissedOverlapHint: false, // video volume and caption volume ovelap
            dismissedDeadAirHint: false, // pauseplay + muted caption audio -> silent pauses; mirrors dismissedOverlapHint
            videoIsMuted: false,
            videoVolume: STANDARD_SETTINGS.videoVolume, // tracks video player volume for share URL
        };
    },
    methods: {
        toggleHome: function () {
            if (firebase.auth.currentUser) {
                this.$router.push({path: "/home"});
            } else {
                this.$router.push({path: "/intro"});
            }
        },
        loginUser: function () {
            if (firebase.auth.currentUser) {
                if (this.$route.hash) {
                    this.$router.replace({path: "/view-post", query: {pid: this.$route.query.pid, postType: this.$route.query.postType}, hash: this.$route.hash});
                } else {
                    this.$router.replace({path: "/view-post", query: {pid: this.$route.query.pid, postType: this.$route.query.postType}});
                }
            } else {
                // save current route info to store so user can be redirected back to correct post when logged in
                // have special checks for group posts?
                this.$router.push({path: "/login"});
            }
        },
        signupUser: function () {
            if (firebase.auth.currentUser) {
                if (this.$route.hash) {
                    this.$router.replace({path: "/view-post", query: {pid: this.$route.query.pid, postType: this.$route.query.postType}, hash: this.$route.hash});
                } else {
                    this.$router.replace({path: "/view-post", query: {pid: this.$route.query.pid, postType: this.$route.query.postType}});
                }
            } else {
                // save current route info to store so user can be redirected back to correct post when signed up
                // have special checks for group posts?
                this.$router.push({path: "/sign-up"});
            }
        },
        consoleLogToUser: function (val) {
            let text = `To use this feature you must be signed in.`;
            if (val === 'name') {
                if (typeof this.postData.username != 'undefined') {
                    text = 'To view this users profile you must be signed in.'
                } else {
                    return;
                }
            } else if (val === 'contribute') {
                this.contributeDialog = true;
                return;
            }
            this.$store.commit('alertUser', { show: true, text: text, type: 'snackbar' });
        },
        pauseAudioPlayer: function () {
            if(this.audioPlayer.duration > 0 && !this.audioPlayer.paused) {
                if(this.playbackStyle == "continuous") {
                    this.audioPlayer.pause();
                }
            }
        },
        playAudioPlayer: function () {
            if (!this.audioPlayer.ended && this.audioPlayer.duration > 0 && this.audioPlayer.paused) {
                if(this.playbackStyle == "continuous") {
                    this.audioPlayer.play();
                }
            }
        },
        currentSegmentIndexForElement: function (audioDataId) {
            // Index of the segment currently playing within the given audio element, or -1 if
            // this element isn't the one playing (or nothing has started). Drives the green
            // "playing-now" row highlight — ports the authenticated route's behavior. Guarded on
            // audioElementHasBegunPlaying so a cold, un-started public post highlights nothing.
            if (!this.audioElementHasBegunPlaying || this.currentAudioSegment == null) return -1;
            if (this.selectedAudioId !== audioDataId) return -1;
            return this.currentAudioSegment.index;
        },
        loadAndPreloadFirstAudioData: async function () {
            // This function is called on initial load of the page and anytime a new AudioElement is clicked.
            // It will load the first AudioSegment into the audioPlayer and if playbackStyle is pauseplay, it
            // will load in the second AudioSegment, otherwise, playbackStyle is continuous, and it will load
            // in the next, or one available after the overlapping segments.

            // load first AudioSegment into this.audioPlayer
            this.audioPlayer.src = this.currentAudioElement.audioData.audio[0].audioURL;
            this.audioPlayer.load();
            // Mobile fallback: Android/iOS browsers often defer audio preloading until a user
            // gesture, so 'canplaythrough' (which is what flips videoLoading to false and enables
            // the player controls) may never fire on a fresh page load. Without this, mobile
            // visitors see no control bar at all and have no way to start the video from the
            // player. If canplaythrough hasn't arrived within 3s, show the controls anyway —
            // the first tap on play is itself the gesture that unlocks audio loading.
            clearTimeout(this.videoLoadingFallbackTimer);
            this.videoLoadingFallbackTimer = setTimeout(() => {
                if (this.videoLoading) this.videoLoading = false;
            }, 3000);
            this.currentAudioSegment = this.currentAudioElement.audioData.audio[0];
            this.currentAudioSegment.index = 0;
            this.currentAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[0].subtitle;
            this.currentAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[0].audioSegId;
            (this.currentAudioSegment.audioStart == 0) && (this.audioElementHasBegunPlaying = true);

            if (this.currentAudioElement.audioData.audio.length > 1) {
                // preload next available AudioSegment so it is ready for playback when its marker is reached.
                if (this.playbackStyle === 'continuous') {
                    // check for overlaps and return the next available AudioSegment index.
                    var nextAvailableIndexAfterOverlap = await this.getNextAvailableIndexAfterOverlap(0,1);
                    if (nextAvailableIndexAfterOverlap !== null) {
                        this.nextAudioSegment = this.currentAudioElement.audioData.audio[nextAvailableIndexAfterOverlap];
                        this.nextAudioSegment.index = nextAvailableIndexAfterOverlap;
                        this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].subtitle;
                        this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].audioSegId;
                    } else {
                        // All AudioSegments in this.currentAudioElement (currently select AudioElement) overlap, unable to set nextAudioSegment.
                        this.nextAudioSegment = null;
                        this.preloadAudioPlayer.src = this.nextAudioSegment;
                        this.preloadAudioPlayer.preload = 'none';
                        this.addAudioPlayerEventListeners();
                        return;
                    }
                } else /*this.playbackStyle == 'pauseplay'*/{
                    // because the video player is paused we wont miss any segments, set next available AudioSegment as second in list, or index 1.
                    this.nextAudioSegment = this.currentAudioElement.audioData.audio[1];
                    this.nextAudioSegment.index = 1;
                    this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[1].subtitle;
                    this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[1].audioSegId;
                }
                // this.preloadAudioPlayer.src = this.nextAudioSegment != null ? this.nextAudioSegment.audioURL : null;
                this.preloadAudioPlayer.src = (this.nextAudioSegment && this.nextAudioSegment.audioURL);
                this.preloadAudioPlayer.preload = 'auto';
            } else {
                // only one AudioSegment to play. No need for preloadAudioPlayer. Destroying preloadAudioPlayer.
                this.nextAudioSegment = null;
                this.preloadAudioPlayer.src = this.nextAudioSegment;
                this.preloadAudioPlayer.preload = 'none';
            }

            // Wait until the end of this function to add event listeners, that way we make sure we get the result of the nextAudioURL
            // before the function stops loading in this.audioCanPlayThrough(). These will set the event listeners to be on for every
            // AudioSegment that plays.
            this.addAudioPlayerEventListeners();
        },
        loadAndPreloadNextAudioData: async function () {
            // set this.preloadAudioPlayer.src (this.nextAudioSegment) to this.audioPlayer.src, since it is already preloaded it should be ready to go when set.
            this.audioPlayer.src = this.preloadAudioPlayer.src;
            this.audioPlayer.load();
            this.currentAudioSegment = this.nextAudioSegment;
            var nextAvailableIndexAfterOverlap;

            if (this.nextAudioSegment != null && (this.currentAudioElement.audioData.audio.length-1) >= (this.nextAudioSegment.index+1)) {
                // preload next available AudioSegment so it is ready for playback when its marker is reached.
                if (this.playbackStyle === 'continuous') {
                    // check for overlaps and return the next available AudioSegment index.
                    nextAvailableIndexAfterOverlap = await this.getNextAvailableIndexAfterOverlap(this.nextAudioSegment.index, this.nextAudioSegment.index+1);
                    if (nextAvailableIndexAfterOverlap !== null) {
                        this.nextAudioSegment = this.currentAudioElement.audioData.audio[nextAvailableIndexAfterOverlap];
                        this.nextAudioSegment.index = nextAvailableIndexAfterOverlap;
                        this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].subtitle;
                        this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].audioSegId;
                    } else {
                        // All AudioSegments in this.currentAudioElement (currently select AudioElement) overlap, unable to set nextAudioSegment.
                        this.nextAudioSegment = null;
                        this.preloadAudioPlayer.src = this.nextAudioSegment;
                        this.preloadAudioPlayer.preload = 'none';
                        return;
                    }
                } else /*this.playbackStyle == 'pauseplay'*/{
                    // because the video player is paused we wont miss any segments, set next available AudioSegment as second in list, or index 1.
                    nextAvailableIndexAfterOverlap = this.nextAudioSegment.index+1; // Check to see if index+1 is out of range, if so set this.nextAudioSegment to null
                    this.nextAudioSegment = this.currentAudioElement.audioData.audio[nextAvailableIndexAfterOverlap];
                    this.nextAudioSegment.index = nextAvailableIndexAfterOverlap;
                    this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].subtitle;
                    this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].audioSegId;
                }
                this.preloadAudioPlayer.src = this.nextAudioSegment.audioURL;
                this.preloadAudioPlayer.preload = 'auto';
            } else {
                // only one AudioSegment to play. No need for preloadAudioPlayer. Destroying preloadAudioPlayer.
                this.nextAudioSegment = null;
                this.preloadAudioPlayer.src = this.nextAudioSegment;
                this.preloadAudioPlayer.preload = 'none';
            }
        },
        loadAndPreloadAudioDataAfterClick: async function (index) {
            // load AudioSegment at index into this.audioPlayer
            this.audioPlayer.src = this.currentAudioElement.audioData.audio[index].audioURL;
            this.audioPlayer.load();
            this.currentAudioSegment = this.currentAudioElement.audioData.audio[index];
            this.currentAudioSegment.index = index;
            this.currentAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[index].subtitle;
            this.currentAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[index].audioSegId;

            if ((this.currentAudioElement.audioData.audio.length-1) >= (index+1)) {
                // preload next available AudioSegment so it is ready for playback when its marker is reached.
                if (this.playbackStyle === 'continuous') {
                    // check for overlaps and return the next available AudioSegment index, if available.
                    var nextAvailableIndexAfterOverlap = await this.getNextAvailableIndexAfterOverlap(index,(index+1));
                    if (nextAvailableIndexAfterOverlap == null) {
                        // All AudioSegments in this.currentAudioElement (currently select AudioElement) overlap, unable to set nextAudioSegment.
                        this.nextAudioSegment = null;
                        this.preloadAudioPlayer.src = this.nextAudioSegment;
                        this.preloadAudioPlayer.preload = 'none';
                        this.addAudioPlayerEventListeners();
                        return;
                    }
                    this.nextAudioSegment = this.currentAudioElement.audioData.audio[nextAvailableIndexAfterOverlap];
                    this.nextAudioSegment.index = nextAvailableIndexAfterOverlap;
                    this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].subtitle;
                    this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[nextAvailableIndexAfterOverlap].audioSegId;
                } else /*this.playbackStyle == 'pauseplay'*/{
                    // because the video player is paused we wont miss any segments, set next available AudioSegment as second in list, or index 1.
                    this.nextAudioSegment = this.currentAudioElement.audioData.audio[(index+1)];
                    this.nextAudioSegment.index = (index+1);
                    this.nextAudioSegment.subtitle = this.currentAudioElement.audioData.subtitles[(index+1)].subtitle;
                    this.nextAudioSegment.subtitleSegment = this.currentAudioElement.audioData.subtitles[(index+1)].audioSegId;
                }
                this.preloadAudioPlayer.src = (this.nextAudioSegment && this.nextAudioSegment.audioURL);
                this.preloadAudioPlayer.preload = 'auto';
            } else {
                // only one AudioSegment to play. No need for preloadAudioPlayer. Destroying preloadAudioPlayer.
                this.nextAudioSegment = null;
                this.preloadAudioPlayer.src = this.nextAudioSegment;
                this.preloadAudioPlayer.preload = 'none';
            }

            // Wait until the end of this function to add event listeners, that way we make sure we get the result of the nextAudioURL
            // before the function stops loading in this.audioCanPlayThrough(). These will set the event listeners to be on for every
            // AudioSegment that plays.
            this.addAudioPlayerEventListeners();
        },
        getNextAvailableIndexAfterOverlap: function (index, indexToCheck) {
            return new Promise( async (resolve) => {
                if (this.currentAudioElement.audioData.audio.length <= indexToCheck) {
                    resolve(null);
                } else {
                    const base = this.currentAudioElement.audioData.audio[index];
                    const baseEnd = base.audioEnd ?? (base.audioStart + base.audioDur);
                    if (baseEnd < this.currentAudioElement.audioData.audio[indexToCheck].audioStart) {
                        resolve(indexToCheck);
                    } else {
                        let recursiveResult = await this.getNextAvailableIndexAfterOverlap(index, indexToCheck+1);
                        resolve(recursiveResult);
                    }
                }
            });
        },
        enableControls: function () {
            this.$refs.vidPlayer.getMarkers().length <= 0 && this.$refs.vidPlayer.placeMarkers(this.currentAudioElement.audioData.audio, this.currentAudioElement.audioData.subtitles, this.currentAudioElement.audioData.username)
        },
        addAudioPlayerEventListeners: function () {
            this.audioPlayer.addEventListener('canplaythrough', this.audioCanPlayThrough/*, {once: true}*/);
            this.audioPlayer.addEventListener("ended", this.audioEnded/*, {once: true}*/);
        },
        removeAudioPlayerEventListeners: function () {
            this.audioPlayer.removeEventListener("canplaythrough", this.audioCanPlayThrough);
            this.audioPlayer.removeEventListener("ended", this.audioEnded/*, {once: true}*/);
        },
        audioCanPlayThrough: function () {
            clearTimeout(this.videoLoadingFallbackTimer); // normal path won the race; cancel the mobile fallback
            this.audioCanPlay = true;
            if (this.videoLoading) this.videoLoading = false;
            // When videoLoading is set to false here, the function videoLoading() in VideoPlayer.vue's watch property
            // gets fired. Which in turn hides the loadingSpinner, shows the bigPlayButton, if necessary, updates the
            // markers and sets player controls to true. When player.controls(true) the .on("controlsenabled") listener
            // gets fired. This will playerPlay() the video player in VideoPlayer.vue and $emit("controlsEnabled") back
            // here to ViewPost.vue, which will call $refs.vidPlayer.placeMarkers();
        },
        audioEnded: function (/*event*/) {
            this.audioCanPlay = false;

            (this.playbackStyle === "pauseplay") && this.$refs.vidPlayer.playerPlay();
            this.$refs.vidPlayer.removeCue(false);
            const hadQueuedSegment = this.nextAudioSegment != null;
            hadQueuedSegment && this.loadAndPreloadNextAudioData();
            if (!hadQueuedSegment && this.currentAudioSegment != null) {
                this.currentAudioSegment = null;
                this.removeAudioPlayerEventListeners();
            }
        },
        timeUpdate: function (time) {
            if (this.videoLoading || this.currentAudioSegment == null || !this.audioPlayer.paused /*|| (this.currentAudioSegment.index == this.currentAudioElement.audioData.audio.length-1)*/) return;
            if (time >= this.currentAudioSegment.audioStart - 0.3) { // timeUpdate is called every 0.2 - 0.3 seconds, so we check for anything + or - 0.3
                this.playbackStyle === "pauseplay" && this.$refs.vidPlayer.playerPause();
                this.$refs.vidPlayer.addCue(this.$refs.vidPlayer.playerGetTime(), this.currentAudioSegment.audioEnd, this.currentAudioSegment.subtitle, this.displayLang);
                this.audioPlayer.play();
            }
        },
        videoPlayerSeeked: function (time) {
            if (this.videoLoading/*|| this.currentAudioSegment.audioStart == 0 && this.audioPlayer.paused*/) return;
            if (this.audioElementOrSegmentClicked) {
                return this.audioElementOrSegmentClicked = false;
            }
            this.videoLoading = true;
            !this.audioPlayer.paused && this.audioPlayer.pause();
            this.removeAudioPlayerEventListeners();
            this.$refs.vidPlayer.hasTextTrack() && this.$refs.vidPlayer.removeCue(true); //this.$refs.vidPlayer.removeTextTrack();

            [this.currentAudioSegment, this.nextAudioSegment] = [null, null];
            let nextAudioSegmentIndex = this.currentAudioElement.audioData.audio.findIndex((data) => {
                if (Math.abs(data.audioStart - time) <= 0.3) {
                    return true;
                }
                if (data.audioStart >= time) {
                    return true;
                }
            });
            if (nextAudioSegmentIndex == -1) {
                this.videoLoading = false;
                return;
            }
            this.loadAndPreloadAudioDataAfterClick(nextAudioSegmentIndex);
        },
        changeSegmentAudio: function (data) {
            //  this function is ran only when a audioSegment is clicked. It will update the markers if necessary and playSelectedAudioSegment
            this.audioElementOrSegmentClicked = true;
            this.videoLoading = true;

            !this.audioPlayer.paused && this.audioPlayer.pause(); // if the player is NOT paused then pause, else nothing;
            this.removeAudioPlayerEventListeners();
            this.$refs.vidPlayer.hasTextTrack() && this.$refs.vidPlayer.removeCue(true); //this.$refs.vidPlayer.removeTextTrack();

            if (this.selectedAudioId === data.audioId) {
                this.$refs.vidPlayer.playerSetTime(data.audioSeg.audioSeg.audioStart);
            } else {
                // formatAE refers to the new AudioElement data, updated to the correct format, that will be set to this.currentAudioElement
                let formatAE = {
                    audioData: data.audioData,
                    audioDataId: data.audioId,
                };
                this.currentAudioElement = formatAE;
                this.selectedAudioId = data.audioId;

                this.$refs.vidPlayer.removeMarkers();
                this.$refs.vidPlayer.playerSetTime(data.audioSeg.audioSeg.audioStart);
                this.$router.replace({path: this.$route.name, query: { pid: this.postData.postId, postType: this.postData.postType, aid: this.selectedAudioId}});

                this.audioElementHasBegunPlaying = false;
            }
            this.loadAndPreloadAudioDataAfterClick(data.audioSeg.index);
        },
        changeElementAudio: function (audioData, audioId) {
            // This function is called Everytime the play button on an AudioElement is clicked.
            // Therefore we must reset the audioSegment number, or else it can/will increment higher
            // Than the actual length of the audioData.

            if (this.selectedAudioId === audioId && !this.audioElementHasBegunPlaying) return;

            this.audioElementOrSegmentClicked = true;
            this.videoLoading = true;

            !this.audioPlayer.paused && this.audioPlayer.pause();
            this.removeAudioPlayerEventListeners();
            this.$refs.vidPlayer.hasTextTrack() && this.$refs.vidPlayer.removeCue(true); //this.$refs.vidPlayer.removeTextTrack();

            if (this.selectedAudioId === audioId && this.audioElementHasBegunPlaying) {
                this.audioElementHasBegunPlaying = false;
                this.$refs.vidPlayer.playerSetTime(0.0);
            } else if (this.selectedAudioId != audioId && !this.audioElementHasBegunPlaying) {
                // This else if statement should only happen if the user presses the play button of an AudioElement right after initial
                // loading is done, but before auto play has started. Shouldn't happen very often, if at all!!!
                this.$refs.vidPlayer.removeMarkers();
                this.currentAudioElement = {
                    audioDataId: audioId,
                    audioData: audioData,
                };
                this.selectedAudioId = audioId;
                this.$router.replace({path: this.$route.name, query: { pid: this.postData.postId, postType: this.postData.postType, aid: this.selectedAudioId}});
            } else {
                this.currentAudioElement = {
                    audioDataId: audioId,
                    audioData: audioData,
                };
                this.selectedAudioId = audioId;

                this.$refs.vidPlayer.removeMarkers();
                this.$refs.vidPlayer.playerSetTime(0.0);
                this.$router.replace({path: this.$route.name, query: { pid: this.postData.postId, postType: this.postData.postType, aid: this.selectedAudioId}});

                this.audioElementHasBegunPlaying = false;
            }
            this.loadAndPreloadFirstAudioData();
        },
        markerReached: function (/*marker*/){ //index, time){
            return false
        },
        markerClicked: function (/*marker*/){ //index, time){
            return false;
        },
        getPostData: function () {
            let publicPostRef = firebase.db.collection("publicPosts").doc(this.postId);
            publicPostRef.get().then((doc) => {
                if (!doc.exists) {
                    this.$store.commit('alertUser', { show: true, text: `This post does not exist.`, type: 'snackbar' });
                    this.postDoesNotExist = true;
                    setTimeout(() => {
                        this.$router.push({path: "/intro"});
                    }, 8000);
                    return;
                }
                var date = doc.data().postDate.toDate().toLocaleDateString();
                this.postData = doc.data();
                this.postData.postDate = date;
                var newSrc = {
                    type: this.postData.videoType,
                    src: this.postData.videoUrl,
                };
                this.vidOptions.sources = newSrc;
                this.viewLoading = false;
                this.descriptionWordCount = this.wordCount();
            }).catch((err) => {
                this.viewLoading = false;
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${err.message}`, type: 'snackbar' });
            });
        },
        advancedControlsUnavailable: function () {
            // The mdi-tune button in the player bar exists on this route but the Advanced
            // Controls panel does not (ViewPost only). The tooltip covers hover on desktop;
            // this snackbar covers taps — especially mobile, where title tooltips never show.
            const text = this.signedInUserId
                ? "Advanced Controls are available in the full viewer."
                : "Log in to access Advanced Controls.";
            this.$store.commit('alertUser', { show: true, text: text, type: 'snackbar' });
        },
        setSearchColor: function(color) {
            this.searchHighlightColor = color;
            localStorage.setItem('tawqSearchColor', color);
        },
        updateSearchMarkers: function(query) {
            if (!this.$refs.vidPlayer) return;
            const q = (query || '').trim().toLowerCase();

            // Always clear previous search markers first so keystrokes don't stack them up.
            // Segment markers (class: 'markers-style' or null) are preserved because
            // removeSearchMarkers only removes class 'search-match-marker'.
            this.$refs.vidPlayer.removeSearchMarkers();

            if (!q) return;

            // Build match markers across all audio elements
            const color = this.searchHighlightColor || '#FF5722';
            const matchMarkers = [];
            const seenKeys = new Set(); // dedupe matches at the same timestamp from same contribution
            this.audioData.forEach(ae => {
                const audio = ae.audioData.audio;
                const username = ae.audioData.username || 'anonymous';
                if (!Array.isArray(audio)) return;

                // Collect all subtitle arrays for this contribution: primary + every language variant
                const subtitleArrays = [];
                if (Array.isArray(ae.audioData.subtitles)) {
                    subtitleArrays.push(ae.audioData.subtitles);
                }
                if (ae.audioData.subtitlesByLanguage && typeof ae.audioData.subtitlesByLanguage === 'object') {
                    for (const arr of Object.values(ae.audioData.subtitlesByLanguage)) {
                        if (Array.isArray(arr)) subtitleArrays.push(arr);
                    }
                }

                audio.forEach((seg, i) => {
                    // A segment matches if ANY of its subtitle arrays contains the query
                    for (const arr of subtitleArrays) {
                        const sub = arr[i];
                        if (sub && sub.subtitle && sub.subtitle.toLowerCase().includes(q)) {
                            // Dedupe: one marker per (contribution + segment) even if multiple
                            // language variants match the same segment
                            const key = `${ae.audioDataId || username}:${i}`;
                            if (seenKeys.has(key)) break;
                            seenKeys.add(key);

                            const snippet = sub.subtitle.length > 40 ? sub.subtitle.substring(0, 40) + '…' : sub.subtitle;
                            matchMarkers.push({
                                time: seg.audioStart,
                                text: `@${username}: ${snippet}`,
                                class: 'search-match-marker',
                            });
                            break;
                        }
                    }
                });
            });
            // Inject marker color into document so .search-match-marker picks it up
            let styleEl = document.getElementById('tawq-search-marker-style');
            if (!styleEl) {
                styleEl = document.createElement('style');
                styleEl.id = 'tawq-search-marker-style';
                document.head.appendChild(styleEl);
            }
            styleEl.textContent = `.search-match-marker { background-color: ${color} !important; width: 4px !important; opacity: 0.9; }`;

            this.$refs.vidPlayer.addSearchMarkers(matchMarkers);

            // Inline-style override: the markers plugin applies its default markerStyle
            // (tawq amber/green) as inline CSS on every marker element, which beats our
            // injected <style> tag. Walk the just-added elements and set the color directly.
            this.$nextTick(() => {
                document.querySelectorAll('.search-match-marker').forEach(el => {
                    el.style.backgroundColor = color;
                });
            });
        },
        adjustSegmentVolume: function (value) {
            this.captionVolume = value == 'mute' ? this.captionVolume > 0.0 ? 0.0 : 1.0 : value
            if (this.playbackStyle == 'continuous') this.$refs.vidPlayer.playerSetVolume(1.0 - this.captionVolume);
            this.audioPlayer.volume = this.captionVolume;
        },
        adjustVideoVolume: function (value) {
            if (!this.$refs.vidPlayer) return;
            this.videoVolume = value;
            const p = this.$refs.vidPlayer.player;
            // VideoJS mute and volume are separate states. If the player is muted (control-bar
            // mute button, or a vv=0 share link), setting volume alone leaves it muted — and the
            // volumechange listener then snaps videoVolume back to 0, so the slider never sticks.
            if (value > 0 && p.muted()) p.muted(false);
            p.volume(value);
        },
        visibilityChanged: function () {
            if (document.hidden) {
                this.$refs.vidPlayer.playerPause();
                this.pauseAudioPlayer();
            }
        },
        getAudioData: function () {
            /*  this function will retrieve the metadata for the audio segments, not the audio itself
            We will query the owners audio segments first, adding them to our local array. after we will
            query every audio segment, and only add it to the array if it hasn't been added yet. Firebase Querying
            does not allow '!=', or for us to use where clause with orderby clause on different fields. */

            this.$refs.vidPlayer.player.on('volumechange', () => {
                var p = this.$refs.vidPlayer.player;
                this.videoIsMuted = p.muted() || p.volume() === 0;
                this.videoVolume = (p.muted() || p.volume() === 0) ? 0 : p.volume();
            });

            // Apply sender's video volume if share link included &vv=
            this.$refs.vidPlayer.player.ready(() => {
                if (this.senderSettingsActive && this.videoVolume !== 1.0) {
                    this.$refs.vidPlayer.player.volume(this.videoVolume);
                }
            });

            this.postViewedCounter = setTimeout(() => {
                this.incrementPostViewed();
            }, 5000);
            this.audioData = [];
            let audioRef = firebase.db.collection("audioSegments").where("postId", "==", this.postData.postId).orderBy("date", "desc");
            audioRef.get().then((snapshot) => {
                if (snapshot.empty) {
                    this.audioLoading = false;
                    return;
                }
                snapshot.forEach((doc) => {
                    let data = {
                        audioData: doc.data(),
                        audioDataId: doc.id,
                    };
                    /* first check to see that there is audio here, then if it is the main audioData that is associated with the post, add it to the front not the back */
                    if (data.audioData.audio.length > 0) {
                        if(data.audioDataId == this.postData.postAudioDataId){
                            this.audioData.unshift(data);
                        } else {
                            this.audioData.push(data)
                        }
                    }
                    if (typeof data.audioData.languageName != 'undefined' && !this.filter.languageCodes.includes(data.audioData.languageName)){
                        this.filter.languageCodes.push(data.audioData.languageName)
                    }
                });
                if (!this.$route.query.aid) {
                    this.selectedAudioId = this.audioData[0].audioDataId; // no aid in url, set first AudioElement to be highlighted.
                    this.$router.replace({path: this.$route.name, query: { pid: this.postData.postId, postType: this.postData.postType, aid: this.selectedAudioId}});
                } else {
                    this.selectedAudioId = this.$route.query.aid; // set this so the AudioElement that will play when clicking video or big play button is highlighted.
                }
                this.currentAudioElement = this.audioData.find(data => data.audioDataId === this.selectedAudioId);
                this.loadAndPreloadFirstAudioData();
                this.audioLoading = false;
            }).catch((err) => {
                console.error(err);
                this.$store.commit('alertUser', { show: true, text: `Something went wrong. ${err.message}`, type: 'snackbar' });
            });
        },
        wordCount: function () {
            if (!this.postData || !this.postData.description) return 0;
            var temp = this.postData.description;
            temp = temp.replace(/(^\s*)|(\s*$)/gi,"");
            temp = temp.replace(/[ ]{2,}/gi," ");
            temp = temp.replace(/\n /,"\n");
            return temp.split(' ').length;
},
        incrementPostViewed: function() {
            if (process.env.NODE_ENV === 'production'){
                let postRef;
                if (typeof this.postData.postId != 'undefined'){
                    postRef = firebase.db.collection(this.postData.postType === 'public' ? "publicPosts" : "groupPosts").doc(this.postData.postId);
                } else if (typeof this.postId != 'undefined'){
                    postRef = firebase.db.collection(this.postType === 'public' ? "publicPosts" : "groupPosts").doc(this.postId);
                } else {
                    return;
                }
                postRef.update({ postViewed: fb.firestore.FieldValue.increment(1),}).catch((error) => {
                    console.error("error incrementing the postViewed:", error.message);
                });
            }
        },
        setPost(timesCalled){
            // setPost() looks to see if we can use the current post from the store. if we can, then we don't have to fetch it from firebase. If we try through 5 ticks, with no success, then we will retrieve the post from firebase.
            // we have to wrap the code in the processNextTick() function because when viewPost is created, the store variable hasn't been set
            if (timesCalled > 5) { 
                // base case: if we have tried this 5 times already, we fallback to getting the post info from firebase;
                this.getPostData();
                return;
            } else {
                this.$nextTick(() => {
                    if(this.currentPost.postId === this.postId){
                        this.postData = { ...this.currentPost };
                        this.descriptionWordCount = this.wordCount();
                        this.vidOptions.sources = {
                            type: this.postData.videoType,
                            src: this.postData.videoUrl,
                        };
                        this.viewLoading = false;
                    } else {
                        this.setPost(timesCalled + 1); // recursively call this function to see if the store has updated
                    }
                });
            }
        },
        muteVideo: function () {
            this.$refs.vidPlayer.player.volume(0);
            this.dismissedOverlapHint = true;
        },
        unmuteCaptionAudio: function () {
            // One-click fix for the dead-air hint: restore caption audio to full, and mark the hint
            // seen so it doesn't reappear if the viewer deliberately mutes again this session.
            this.adjustSegmentVolume(1.0);
            this.dismissedDeadAirHint = true;
        },
        // X on the status bar: hides the notice for the session without changing playback. Sender
        // settings stay in effect; any hints that were showing are marked seen.
        dismissStatusBar: function () {
            this.senderSettingsActive = false;
            if (this.showOverlapHint) this.dismissedOverlapHint = true;
            if (this.showDeadAirHint) this.dismissedDeadAirHint = true;
        },
        // "Use standard settings" — free, no account. Reverts the four settings a &share= link can
        // touch back to STANDARD_SETTINGS, restores the video player volume/mute, drops the sender
        // flag, and strips the share params from the URL (guarded against vue-router's
        // NavigationDuplicated when there are none to remove).
        useStandardSettings: function () {
            this.playbackStyle = STANDARD_SETTINGS.playbackStyle;
            this.showCaptions = STANDARD_SETTINGS.showCaptions;
            this.captionVolume = STANDARD_SETTINGS.captionVolume;
            this.audioPlayer.volume = this.captionVolume;
            // In continuous the video ducks under caption audio (1.0 - captionVolume); else full.
            const standardVideoVolume = this.playbackStyle === 'continuous'
                ? Math.max(0, 1.0 - this.captionVolume)
                : STANDARD_SETTINGS.videoVolume;
            if (this.$refs.vidPlayer && this.$refs.vidPlayer.player) {
                this.adjustVideoVolume(standardVideoVolume); // unwinds muted state so the change sticks
            } else {
                this.videoVolume = standardVideoVolume;
            }
            this.senderSettingsActive = false;
            if (this.$route.query.share !== undefined) {
                this.$router.replace({ query: { pid: this.postData.postId, postType: this.postData.postType, aid: this.selectedAudioId } });
            }
        },
        goToSignIn: function () {
            // Public route -> sign-in, so the viewer can save their own preferences.
            this.$router.push({ path: "/login" });
        },

    },
    computed: {
        isMobile(){
            return this.$store.state.isMobileDevice;
        },
        isIOS(){
            return this.$store.state.isIOSDevice;
        },
        languageFilteredAudio(){
            if(this.filter.languageSelected === "All"){
                return this.audioData;
            } else {
                return this.audioData.filter( audio => audio.audioData.languageName === this.filter.languageSelected );
            }
        },
        leftAudioData(){
            return this.audioData.filter((num, index) => index%2 === 0);
        },
        rightAudioData(){
            return this.audioData.filter((num, index) => index%2 != 0);
        },
        currentPost(){
            return this.$store.state.currentPost;
        },
        showOverlapHint() {
            return this.playbackStyle === 'continuous'
            && this.audioElementHasBegunPlaying // not before playback starts — no "is playing" on a cold load
            && this.showCaptions
            && this.captionVolume > 0
            && !this.videoIsMuted
            && !this.dismissedOverlapHint;
        },
        // Dead-air hint: pauseplay pauses the video for each segment while caption audio plays;
        // if that audio is muted, every pause is silence. Educational, once per session, mirrors
        // showOverlapHint. Informs only — never changes a setting.
        showDeadAirHint() {
            return this.playbackStyle === 'pauseplay'
                && this.captionVolume === 0
                && !this.dismissedDeadAirHint;
        },
        // $store.state.userData is null for signed-out visitors: main.js dispatches unbindUserData
        // on sign-out / anonymous load, and vuexfire resets the bound value to null. Reading
        // .userId off null throws during render, which aborts the whole component and produces a
        // black page on the public route. Every userData read here goes through this guard.
        signedInUserId() {
            return this.$store.state.userData ? this.$store.state.userData.userId : null;
        },
        // Public-route status bar: shown only when a share link overrides playback or a hint
        // applies. No anomaly/baseline compare — an anonymous viewer has no saved defaults to
        // drift from, so viewer-driven tweaks never raise it.
        showSettingsStatusBar() {
            return this.senderSettingsActive || this.showOverlapHint || this.showDeadAirHint;
        },
    },
    watch: {
        searchQuery: function(newVal) {
            this.updateSearchMarkers(newVal);
            // If search is cleared, collapse the color picker so it's fresh next time
            if (!newVal || !newVal.trim()) this.showColorPicker = false;
        },
        searchHighlightColor: function() {
            // Re-render search markers in new color. updateSearchMarkers always clears
            // previous search markers first, so no explicit cleanup needed here.
            if (this.searchQuery && this.searchQuery.trim()) {
                this.updateSearchMarkers(this.searchQuery);
            }
        },
        playbackStyle: function (newVal) {
            // When leaving continuous mode, restore video to full volume.
            // When entering continuous mode, apply the crossfade.
            if (!this.$refs.vidPlayer) return;
            if (newVal === 'continuous') {
                this.$refs.vidPlayer.playerSetVolume(1.0 - this.captionVolume);
            } else {
                this.$refs.vidPlayer.playerSetVolume(1.0);
            }
            // Re-place markers so skipped-segment styling and marker positions
            // match the new playback mode. $nextTick: wait for the child's
            // playbackStyle prop to propagate before restyling.
            this.$nextTick(() => {
                if (!this.currentAudioElement || this.$refs.vidPlayer.getMarkers().length <= 0) return;
                this.$refs.vidPlayer.removeMarkers();
                this.$refs.vidPlayer.placeMarkers(this.currentAudioElement.audioData.audio, this.currentAudioElement.audioData.subtitles, this.currentAudioElement.audioData.username);
                if (this.searchQuery && this.searchQuery.trim()) this.updateSearchMarkers(this.searchQuery); // removeAll wiped search markers too
            });
        },
    },
    beforeDestroy: function () {
        this.audioPlayer.pause();
        this.audioPlayer.remove();
        document.removeEventListener("visibilitychange", this.visibilityChanged);
        clearTimeout(this.postViewedCounter);
        clearTimeout(this.videoLoadingFallbackTimer);
    },
    created: async function () {
        // console.log("postId: ", this.postId);
        if (this.postType == "group") {
            this.$store.commit('alertUser', { show: true, text: `This post can only be seen by members of the group it belongs to.`, type: 'snackbar' });
            this.audioLoading = false;
            this.showIsGroupPostIndicator = true;
        } else {
            this.setPost(1);
            if (this.isIOS) {
                // console.log("iphone doesn't allow continuous playback, because it can't have two media elements playing at once. Default to pauseplay");
                this.playbackStyle ='pauseplay';
            }
        }
    },
    mounted: function () {
        document.addEventListener("visibilitychange", this.visibilityChanged);

        // Sender settings override — applied when share link includes &share=1
        // Session-only. Never writes to localStorage.
        const q = this.$route.query;
        if (q.share === '1') {
            if (q.ps === 'continuous' || q.ps === 'pauseplay') {
                this.playbackStyle = q.ps;
            }
            if (q.sc !== undefined) {
                this.showCaptions = q.sc === '1';
            }
            if (q.cv !== undefined) {
                const vol = parseFloat(q.cv);
                if (!isNaN(vol) && vol >= 0 && vol <= 1) {
                    this.captionVolume = vol;
                    this.audioPlayer.volume = vol;
                }
            }
            if (q.vv !== undefined) {
                const vol = parseFloat(q.vv);
                if (!isNaN(vol) && vol >= 0 && vol <= 1) {
                    this.videoVolume = vol;
                }
            }
            this.senderSettingsActive = true;
        }
    },
  
};

</script>


<style scoped>
.v-input >>> .v-input__prepend-outer {
    margin-right: 0 !important;
}

.v-input >>> .v-input__append-outer {
    margin-left: 0 !important;
}

.expand {
    min-height: 105px !important;
    max-height: 600px !important;
    padding-bottom: 1em;
    overflow-y: scroll !important;
}

.faded {
    position: absolute; 
    bottom: 1em;
    width:100%;
    height: 3em;
    background-image: linear-gradient(to bottom, rgba(255,255,255, 0) 0%, rgba(255,255,255, 1) 80%);
}

.faded-dark {
    position: absolute; 
    bottom: 1em;
    width:100%;
    height: 3em;
    background-image: linear-gradient(to bottom, rgba(0,0,0, 0) 0%,rgba(18,18,18, 1) 80%);
    transition: display .4s;
}

.bordered {
    background-color: var(--v-background-base);
    /* border: 5px solid var(--v-background-base); */
    border-radius: 25px;
}

.v-skeleton-loader__image {
    height: 100%;
}
</style>